import React from 'react'
import { EditInvoiceConfigFlowProvider } from './context/EditInvoiceConfigFlowProvider'
import { EditInvoiceConfigFlowMain } from './components/EditInvoiceConfigFlowMain'
import { useInvoiceConfigWorkflowsContextValue } from '../../context/InvoiceConfigWorkflowsProvider'

export const EditInvoiceConfigFlow = () => {
  const { editInvoiceConfigFlow } = useInvoiceConfigWorkflowsContextValue()

  if (!editInvoiceConfigFlow.invoiceConfig) {
    return null
  }

  return (
    <EditInvoiceConfigFlowProvider>
      <EditInvoiceConfigFlowMain
        invoiceConfig={editInvoiceConfigFlow.invoiceConfig}
      />
    </EditInvoiceConfigFlowProvider>
  )
}
